import axios from "axios";

const APP_URL = process.env.NEXT_PUBLIC_APP_URL;

const axiosPrivate = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
    "x-domain": APP_URL,
  },
});

export default axiosPrivate;
